export default __webpack_public_path__ + "58b6508dbaeac285d4af077b33e46aad.png";